<template>
  <div class="bg-white rounded-sm m-2">
    <b-row>
      <b-modal title="Application Details" ref="applicationDetails" size="xl" hide-footer>
        <AdministrationApplicationDetails :tracking-number="trackingNumber"/>
      </b-modal>
    </b-row>
    <b-row>
      <b-col cols="12" class="mx-3 mt-3">
        <b-row>
          <span class="title">Company Insolvency Applications</span>
        </b-row>
      </b-col>
    </b-row>
<!--    <b-row class="flex mx-3 mt-3">
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="pre-waiting">
          <span class="h3 mx-auto">{{getInsolvencyStatistics.stats.DRAFT}}</span>
        </div>
        <div class="pre-waiting">
          <span class="text-sm mx-auto">Drafts</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="waiting">
          <span class="h3 mx-auto">{{getInsolvencyStatistics.stats.SUBMITTED}}</span>
        </div>
        <div class="waiting">
          <span class="text-sm mx-auto">In Queue</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="normal">
          <span class="h3 mx-auto">{{getInsolvencyStatistics.stats.ASSIGNED}}</span>
        </div>
        <div class="normal">
          <span class="text-sm mx-auto">Assigned</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="off-normal">
          <span class="h3 mx-auto">{{getInsolvencyStatistics.stats.ESCALATED}}</span>
        </div>
        <div class="off-normal">
          <span class="text-sm mx-auto">Escalated</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="warning">
          <span class="h3 mx-auto">{{getInsolvencyStatistics.stats.QUERIED}}</span>
        </div>
        <div class="warning">
          <span class="text-sm mx-auto">Queried</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="positive">
          <span class="h3 mx-auto">{{getInsolvencyStatistics.stats.APPROVED}}</span>
        </div>
        <div class="positive">
          <span class="text-sm mx-auto">Approved</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="all">
          <span class="h3 mx-auto">{{getInsolvencyStatistics.total}}</span>
        </div>
        <div class="all">
          <span class="text-sm mx-auto">Total</span>
        </div>
      </div>
    </b-row>

      <b-row class="flex mx-3 mt-3">
          <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
              <div class="pre-waiting">
                  <span class="h3 mx-auto">{{getInsolvencyStatistics.stats.PRELIMINARY_REPORT}}</span>
              </div>
              <div class="pre-waiting">
                  <span class="text-sm mx-auto">Prelim Report</span>
              </div>
          </div>
          <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
              <div class="waiting">
                  <span class="h3 mx-auto">{{getInsolvencyStatistics.stats.NOTICE}}</span>
              </div>
              <div class="waiting">
                  <span class="text-sm mx-auto">Notice</span>
              </div>
          </div>
          <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
              <div class="positive">
                  <span class="h3 mx-auto">{{getInsolvencyStatistics.stats.FINAL_REPORT}}</span>
              </div>
              <div class="positive">
                  <span class="text-sm mx-auto">Final report</span>
              </div>
          </div>
          <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
              <div class="danger">
                  <span class="h3 mx-auto">{{getInsolvencyStatistics.stats.EXPIRED}}</span>
              </div>
              <div class="danger">
                  <span class="text-sm mx-auto">Expired</span>
              </div>
          </div>
          <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
              <div class="waiting">
                  <span class="h3 mx-auto">{{getInsolvencyStatistics.stats.INTERIM_REPORT_NOTICE}}</span>
              </div>
              <div class="waiting">
                  <span class="text-sm mx-auto">Interim Notice</span>
              </div>
          </div>
          <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
              <div class="positive">
                  <span class="h3 mx-auto">{{getInsolvencyStatistics.stats.PRELIMINARY_NOTICE}}</span>
              </div>
              <div class="positive">
                  <span class="text-sm mx-auto">Prelim Notice</span>
              </div>
          </div>
          <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
              <div class="off-normal">
                  <span class="h3 mx-auto">{{getInsolvencyStatistics.stats.INTERIM_REPORT}}</span>
              </div>
              <div class="off-normal">
                  <span class="text-sm mx-auto">Interim Report</span>
              </div>
          </div>
      </b-row>-->
    <b-row class="flex">
      <b-col cols="12">
        <b-row class="pt-3">
          <b-col>
             <AllAdministrationSubmissions v-on:openDetails="openDetails"/>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import AllAdministrationSubmissions
    from "@/views/home/services/insolvency/submissions/AllAdministrationSubmissions.vue";
import AdministrationApplicationDetails
    from "@/views/home/services/insolvency/task-queue/AdministrationApplicationDetails.vue";

export default {
  name: "AdministrationApplications",
  components: {
      AdministrationApplicationDetails,
      AllAdministrationSubmissions,

  },
  data(){
    return{
      currentRoute: null,
      trackingNumber:null,
       applications:"winding-up"
    }
  },
  mounted(){
      this.currentRoute = this.$route.fullPath;

      if (this.currentRoute.includes("receivership-queue-task")) {
        this.currentRoute = "receivership"
      }

    this.fetchInsolvencyStatistics("WINDING_UP,FOREIGN_COMPANY_DE_REGISTRATION,RECEIVERSHIP,ADMINISTRATION,BANKRUPTCY_FILING")
  },
  methods:{
    ...mapActions(["fetchInsolvencyStatistics"]),
    select(route){
      this.currentRoute = route
    },
    openDetails(trackingNumber){
      this.trackingNumber = trackingNumber
      this.$refs.applicationDetails.show()
    }
  },
  computed:{
    ...mapGetters(["getInsolvencyStatistics"])
  }
}
</script>

<style scoped>


.pre-waiting{
  @apply flex text-gray_title;
}

.off-normal{
  @apply flex text-blue-light;
}

.waiting{
  @apply flex text-gray;
}

.normal{
  @apply flex text-blue;
}

.positive{
  @apply flex text-green;
}

.warning{
  @apply flex text-orange;
}

.danger{
    @apply flex text-red;
}

.all{
  @apply flex text-flopurple;
}

.stat-count{
  display: inline;
  width: 12%;
  @apply my-1;
}
</style>